// extracted by mini-css-extract-plugin
export default {"GraphHoverInfo":"styles_GraphHoverInfo__iPW4y","title":"styles_title__gWmP0","value":"styles_value__CeJ7f"};